<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">Toolbox</div>
    <div>
        <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>
@if (!toolboxEdit) {
    <div class="dialog-content" mat-dialog-content>
        <p>Er kan maximaal 1 toolbox tegelijk getoond worden</p>
        <table class="table table-hover table-last-col table-add-row">
            <thead>
                <tr>
                    <th>Begin</th>
                    <th>Eind</th>
                    <th>Gelezen</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (toolbox of toolboxes; track toolbox) {
                    <tr class="curpoint" (click)="edit(toolbox)">
                        <td>
                            {{ toolbox.begindate | date: 'EEEE d MMMM yyyy' }}
                        </td>
                        <td>
                            {{ toolbox.enddate | date: 'EEEE d MMMM yyyy' }}
                        </td>
                        <td>
                            {{ toolbox.read_count }}
                        </td>
                        <td>
                            <div class="d-flex">
                                <button class="me-2" (click)="readBy($event, toolbox)" color="primary" mat-icon-button>
                                    <mat-icon class="fa-solid fa-glasses"></mat-icon>
                                </button>
                                <button (click)="delete($event, toolbox)" color="warn" mat-icon-button>
                                    <mat-icon class="fas fa-trash"></mat-icon>
                                </button>
                            </div>
                        </td>
                    </tr>
                }
                <tr>
                    <td colspan="3">
                        <button class="w-100" (click)="edit()" color="primary" mat-button>
                            Een toolbox toevoegen <i class="fas fa-plus"></i>
                        </button>
                    </td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
}

@if (toolboxEdit) {
    <div class="dialog-content" mat-dialog-content>
        <app-toolbox-edit [toolbox]="toolboxEdit" [toolboxes]="toolboxes" (back)="back()"> </app-toolbox-edit>
    </div>
}
